import {
  Button,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { StyledTableCell } from "../../../../MaterialTheme/themes";
import { BASE_URL, sendData } from "../../../../Models/Fetcher";
import {
  codeTableTypeState,
  popupState,
  refreshTables,
  updatedRecord,
  updatedRecordType3,
} from "../../../../Store/atoms";
import { blurRoot, unBlurRoot } from "../../../../Utilities/DOMFunctions";
import TableHeader from "../../../RecordsTable/TableHeader";

import "./styles.css";

const useStyles = makeStyles({
  deleteButton: {
    backgroundColor: "#dc3545",
    color: "white",
    marginLeft: "2rem",
    "&:hover": {
      color: "white",
      backgroundColor: "#a3001e",
    },
  },

  closeButton: {
    marginRight: "2rem",
  },
});
export default () => {
  const record2 = useRecoilValue(updatedRecord);
  const record3 = useRecoilValue(updatedRecordType3);

  const setPopup = useSetRecoilState(popupState);
  const classes = useStyles();
  const setRefresh = useSetRecoilState(refreshTables);

  const recordTableType = useRecoilValue(codeTableTypeState);

  let record: any = recordTableType === 3 ? record3 : record2;

  blurRoot();

  const handleDelete = async (e: any) => {
    const deleteURL =
      BASE_URL + "records-" + recordTableType + "/" + record?.id;
    const response = await sendData(deleteURL, "DELETE", {});
    if (record !== null) {
      setRefresh(record.type_id);
    }

    close(e);
  };
  const close = (e: any) => {
    unBlurRoot();
    setPopup(null);
  };

  return (
    <div className="delete-record">
      <div className="delete__message">
        Are you sure you want to delete this record?
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              {recordTableType === 3 && (
                <>
                  <StyledTableCell>OmniumType</StyledTableCell>
                  <StyledTableCell>CustomerValue</StyledTableCell>
                </>
              )}

              {recordTableType === 2 && (
                <>
                  <StyledTableCell>OmniumValue</StyledTableCell>
                  <StyledTableCell>CustomerValue</StyledTableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              {recordTableType === 3 && (
                <>
                  <StyledTableCell>{record.type_name}</StyledTableCell>
                  <StyledTableCell>{record.customer_value}</StyledTableCell>
                </>
              )}

              {recordTableType === 2 && (
                <>
                  <StyledTableCell>{record?.omnium_value}</StyledTableCell>
                  <StyledTableCell>{record?.customer_value}</StyledTableCell>
                </>
              )}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <div className="control-buttons">
        <Button
          variant="contained"
          className={classes.closeButton}
          onClick={close}
        >
          CANCEL
        </Button>
        <Button
          variant="contained"
          className={classes.deleteButton}
          onClick={handleDelete}
        >
          DELETE
        </Button>
      </div>
    </div>
  );
};
